import { render, staticRenderFns } from "./noData.vue?vue&type=template&id=07f2ee1f&scoped=true&"
var script = {}
import style0 from "./noData.vue?vue&type=style&index=0&id=07f2ee1f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f2ee1f",
  null
  
)

export default component.exports